// This hook allows a component to be dismissed and remember this dismiss for
// a period of time specified in seconds
//
// Returns:
//   show - state of whether to show the component or not
//   dismiss - call when user requests to dismiss the component

import { useState, useEffect } from "react";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export default function (key, seconds) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (cookies.get(key) === "1") {
      setShow(false);
    }
  }, []);

  const dismiss = () => {
    cookies.set(key, "1", {
      maxAge: seconds,
      path: "/",
    });

    setShow(false);
  };

  return [show, dismiss];
}
